import React, {Suspense} from 'react';
import {Switch} from 'react-router-dom';
import {UsersActionsPage} from './components/UsersActionsPage';
import {LayoutSplashScreen, ContentRoute} from '../../../_metronic/layout';

export default function UsersActionsPageContainer() {
  return (
    <Suspense fallback={<LayoutSplashScreen/>}>
      <Switch>
        <ContentRoute path="/logs-users-actions" component={UsersActionsPage}/>
      </Switch>
    </Suspense>
  );
}
